import { Navigate } from 'react-router-dom';
import { AppGuard } from '@/components/guards/AppGuard';
import { OnboardingFlow } from '@/features/onboarding/components/OnboardingFlow';
import { Dashboard } from '@/components/dashboard/Dashboard';
import Login from '@/components/auth/Login';
import SignUp from '@/components/auth/SignUp';
import { WelcomePage } from '@/pages/WelcomePage';
import { InitialAssessmentPage } from '@/routes/assessment/InitialAssessmentPage';
import LandingPage from '@/components/landing/LandingPage';
import { CareerPathsPage } from '@/pages/CareerPathsPage';
import { AchievementsPage } from '@/pages/AchievementsPage';

export const routes = [
  {
    path: '/',
    element: <LandingPage />
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/signin',
    element: <Navigate to="/login" replace />
  },
  {
    path: '/signup',
    element: <SignUp />
  },
  {
    path: '/welcome',
    element: (
      <AppGuard>
        <WelcomePage />
      </AppGuard>
    )
  },
  {
    path: '/dashboard',
    element: (
      <AppGuard>
        <Dashboard />
      </AppGuard>
    )
  },
  {
    path: '/onboarding',
    element: (
      <AppGuard>
        <OnboardingFlow />
      </AppGuard>
    )
  },
  {
    path: '/assessment',
    element: (
      <AppGuard>
        <InitialAssessmentPage />
      </AppGuard>
    )
  },
  {
    path: '/career-paths',
    element: (
      <AppGuard>
        <CareerPathsPage />
      </AppGuard>
    )
  },
  {
    path: '/achievements',
    element: (
      <AppGuard>
        <AchievementsPage />
      </AppGuard>
    )
  },
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
];